
import axios from './rest-axios';

const getCalendar = (start_time,end_time) => axios.get(`/manage/calendar/`,{start_time,end_time});

export {
    getCalendar
};
